module.exports = __webpack_public_path__ + "img/location.7cc95aa.svg";